export default __webpack_public_path__ + "static/media/nutrionist@3x.e23886d9.png";